<template>
  <div>
    <q-select
      :data-cy="nameCypress"
      :label="placeholder"
      :option-label="optionValue"
      :hint="hint"
      :input-debounce="debounce"
      :options="optionsSelect"
      use-input
      emit-value
      map-options
      clearable
      options-dense
      hide-selected
      fill-input
      outlined
      autofocus
      @filter="emitFilter"
      :readonly="isSearching"
      @input="emitInput"
      v-model="inputSelect"
    >
      <template v-slot:no-option>
        <q-item v-if="showNoOption">
          <q-item-section class="text-grey"> {{ noOption }} </q-item-section>
        </q-item>
      </template>
      <template v-if="optionValueItems.length > 0" v-slot:option="scope">
        <q-item v-bind="scope.itemProps" v-on="scope.itemEvents" class="item-container">
          <q-item-section>
            <q-item-label v-for="item in optionValueItems" :key="item.id">{{ scope.opt[item] ? scope.opt[item] : '-' }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    debounce: {
      type: Number,
      default: 1000
    },
    optionValue: {
      type: String,
      required: true
    },
    noOption: {
      type: String,
      default: ''
    },
    optionsSelect: {
      type: Array,
      required: true,
      default: () => []
    },
    nameCypress: {
      type: String
    },
    isSearching: {
      type: Boolean,
      required: true,
      default: false
    },
    showNoOption: {
      type: Boolean,
      required: false,
      default: () => true
    },
    optionValueItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      inputSelect: null
    };
  },
  methods: {
    emitFilter (val, update, abort) {
      this.$emit('filterEvent', val, update, abort);
    },
    emitInput (d) {
      this.$emit('input', d);
    }
  }
};
</script>
<style lang="scss" scoped>
.item-container {
  padding: 10px;
}
</style>
